import Axios from "axios";

export const SelectBLBRLig = (num, a, b, c, d, e) => {
  return (dispatch) => {
    Axios.get(
      `https://www.24-crm.tn/webservice/Api/LigBLBRs?type=BR&numfac=${num}&coddos=${a}&serveur=${b}&user=${c}&pwd=${d}&database=${e}`
    ).then((response) => {
      return dispatch({ type: "BLBR_LIG_SELECT", payload: response.data });
    });
  };
};
